<template>
  <article class="ut-cierre">
    <header class="ut-cierre-cabecera">
      <dl><div v-for="campo in modelo.cabecera" :key="campo.titulo"><dt>{{ campo.titulo }}</dt><dd>{{ campo.valor }}</dd></div></dl>
      <p v-if="modelo.nombreCaja">{{ modelo.nombreCaja }}</p>
    </header>
    <div class="ut-cierre-columnas">
      <section class="ut-cierre-conteo">
        <h3>Conteo de caja</h3>
        <table class="ut-cierre-tabla"><caption class="ut-cierre-sr">Tarjetas y cheques</caption><thead><tr><th scope="col">Medio</th><th scope="col">Cantidad</th><th scope="col">Valor</th></tr></thead><tbody><tr v-for="pago in modelo.pagos" :key="pago.titulo"><th scope="row">{{ pago.titulo }}</th><td>{{ pago.cantidad }}</td><td>{{ pago.monto }}</td></tr></tbody></table>
        <table class="ut-cierre-tabla ut-cierre-denominaciones"><caption class="ut-cierre-sr">Denominaciones de efectivo</caption><thead><tr><th scope="col">Moneda</th><th scope="col">Cantidad</th><th scope="col">Valor</th></tr></thead><tbody><tr v-for="moneda in modelo.denominaciones" :key="moneda.valor"><th scope="row">{{ moneda.valor }}</th><td>{{ moneda.cantidad }}</td><td>{{ moneda.monto }}</td></tr></tbody></table>
        <div class="ut-cierre-total"><span>Efectivo</span><strong>{{ modelo.efectivo }}</strong></div>
        <table class="ut-cierre-tabla ut-cierre-boletos"><caption>Boletos</caption><thead><tr><th scope="col">Estado</th><th scope="col">Cantidad</th><th scope="col">Monto</th></tr></thead><tbody><tr v-for="boleto in modelo.boletos" :key="boleto.titulo"><th scope="row">{{ boleto.titulo }}</th><td>{{ boleto.cantidad }}</td><td>{{ boleto.monto }}</td></tr></tbody></table>
      </section>
      <section class="ut-cierre-ventas">
        <h3>Datos de ventas</h3>
        <dl><div v-for="venta in modelo.ventas" :key="venta.titulo"><dt>({{ venta.signo }}) {{ venta.titulo }}</dt><dd>{{ venta.valor }}</dd></div></dl>
        <div class="ut-cierre-total ut-cierre-esperado"><span>Total que debe haber para cuadre</span><strong>{{ modelo.total }}</strong></div>
      </section>
    </div>
    <footer class="ut-cierre-diferencia" :data-estado="modelo.estado"><div><span>Diferencia</span><strong>{{ modelo.diferencia }}</strong></div><b>{{ modelo.estado }}</b></footer>
  </article>
</template>

<script>
import { detalleCierre } from './detalleCierre';
export default {
  name: 'DetalleCierreCaja', props: { datos: { type: Object, required: true } },
  computed: { modelo() { return detalleCierre(this.datos); } },
};
</script>

<style scoped>
.ut-cierre { color: #253747; background: #fff; font-size: 13px; line-height: 1.4; letter-spacing: 0; }
.ut-cierre * { box-sizing: border-box; letter-spacing: 0; }
.ut-cierre dl, .ut-cierre dd, .ut-cierre p { margin: 0; }
.ut-cierre-cabecera { padding: 14px 20px; background: #eaf2f8; border-bottom: 1px solid #cfdee9; }
.ut-cierre-cabecera dl { display: grid; grid-template-columns: 1fr 1fr 1.3fr 1.5fr; gap: 12px; }
.ut-cierre dt { font-size: 12px; color: #4a6070; }
.ut-cierre-cabecera dd { margin-top: 3px; font-weight: 700; }
.ut-cierre-cabecera p { margin-top: 10px; font-size: 12px; }
.ut-cierre-columnas { display: grid; grid-template-columns: 1fr 1fr; }
.ut-cierre section { min-width: 0; padding: 14px 20px; }
.ut-cierre h3 { font-size: 14px; margin: 0 0 10px; line-height: 1.4; }
.ut-cierre-ventas { background: #f3f6f8; border-left: 1px solid #d5dce1; display: flex; flex-direction: column; }
.ut-cierre-ventas dl { flex: 1; }
.ut-cierre-ventas dl > div { padding: 9px 0; }
.ut-cierre-ventas dd { text-align: right; font-size: 16px; font-weight: 700; margin-top: 3px; font-variant-numeric: tabular-nums; }
.ut-cierre-tabla { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 12px; }
.ut-cierre-tabla th, .ut-cierre-tabla td { padding: 4px 3px; text-align: right; font-variant-numeric: tabular-nums; }
.ut-cierre-tabla th:first-child { text-align: left; width: 28%; }
.ut-cierre-tabla th:nth-child(2) { width: 25%; }
.ut-cierre-tabla thead { color: #526575; border-bottom: 1px solid #d5dce1; }
.ut-cierre-tabla thead th { font-weight: 500; }
.ut-cierre-denominaciones { margin-top: 15px; }
.ut-cierre-tabla caption { text-align: left; font-size: 14px; font-weight: 700; padding-bottom: 6px; }
.ut-cierre-boletos { margin-top: 14px; }
.ut-cierre-total { border-top: 1px solid #cbd7df; padding-top: 10px; margin-top: 8px; display: flex; flex-wrap: wrap; align-items: baseline; justify-content: space-between; gap: 6px; }
.ut-cierre-total strong { font-size: 21px; font-variant-numeric: tabular-nums; }
.ut-cierre-esperado { flex-direction: column; align-items: stretch; }
.ut-cierre-esperado strong { text-align: right; }
.ut-cierre-diferencia { border-top: 1px solid #d5dce1; padding: 16px 20px; display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ut-cierre-diferencia strong { display: block; font-size: 26px; font-variant-numeric: tabular-nums; }
.ut-cierre-diferencia[data-estado="Sobrante"] { color: #235b95; background: #eff6fc; }
.ut-cierre-diferencia[data-estado="Faltante"] { color: #a62732; background: #fff3f3; }
.ut-cierre-diferencia[data-estado="Cuadrado"] { color: #1e6646; background: #eef7f1; }
.ut-cierre dd, .ut-cierre td, .ut-cierre th, .ut-cierre strong, .ut-cierre b { overflow-wrap: anywhere; }
.ut-cierre-sr { position: absolute; width: 1px; height: 1px; padding: 0 !important; overflow: hidden; clip: rect(0,0,0,0); }
@media (max-width: 600px) {
  .ut-cierre-cabecera { padding: 12px; }
  .ut-cierre-cabecera dl { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .ut-cierre-columnas { grid-template-columns: minmax(0, 1fr); }
  .ut-cierre section { padding: 14px 12px; }
  .ut-cierre-ventas { border-left: 0; border-top: 1px solid #d5dce1; }
  .ut-cierre-diferencia { padding: 14px 12px; flex-wrap: wrap; }
}
</style>
